
function HorisontalRule() {
  return (
    <div className="section-shell">
      <hr className="site-rule" />
    </div>
  );
}

export default HorisontalRule;
